/** Query stale times by churn frequency */
export const STALE_TIMES = {
  /** Products, Variants, Discounts, Menu Items, Taxons — changes during active work */
  HIGH_CHURN: 2 * 60 * 1000,
  /** Suppliers, Users, Companies, Accounting Groups/Segments — session default */
  DEFAULT: 5 * 60 * 1000,
  /** Locations, Payment Methods, Printers, Measurement Units, Tax Rates, Brands */
  LOW_CHURN: 10 * 60 * 1000,
  /** Roles, Sales Channels, Customer Segments, Barcode/Toolbar/Navigation Configs */
  STATIC: Infinity
} as const

/** Garbage collection times */
export const GC_TIMES = {
  /** Default GC — generous but bounded */
  DEFAULT: 15 * 60 * 1000,
  /** Extended GC for static data */
  EXTENDED: 30 * 60 * 1000
} as const

/** Default debounce for search composables */
export const DEFAULT_SEARCH_DEBOUNCE = 400
